import { render, staticRenderFns } from "./locataire-non-couvert.vue?vue&type=template&id=5f144227&scoped=true"
import script from "./locataire-non-couvert.vue?vue&type=script&lang=ts"
export * from "./locataire-non-couvert.vue?vue&type=script&lang=ts"
import style0 from "./locataire-non-couvert.vue?vue&type=style&index=0&id=5f144227&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f144227",
  null
  
)

export default component.exports